import { useId } from 'react';
import { cn } from '../lib/cn';

export interface RtkLogoProps {
  className?: string;
  /** Показывать словесную часть «Ростелеком» рядом со знаком. */
  withWordmark?: boolean;
}

/**
 * Фирменный знак «Ростелеком». Геометрия — из статики msk.rt.ru
 * (см. `assets/brand/README.md`); словесная часть набрана текстом,
 * потому что оригинальный Basis Grotesque Pro проприетарный.
 */
export function RtkLogo({ className, withWordmark = true }: RtkLogoProps) {
  const gradientId = `rtk-mark-fold-${useId()}`;
  return (
    <span className={cn('flex items-center gap-2', className)}>
      <svg
        viewBox="0 0 60 100"
        className="h-6 w-auto shrink-0"
        role="img"
        aria-label="Ростелеком"
        focusable="false"
      >
        <defs>
          <linearGradient id={gradientId} x1="52.458618%" y1="71.0031767%" x2="29.7848651%" y2="22.6635568%">
            <stop stopColor="#F05223" offset="0%" />
            <stop stopColor="#BA341C" offset="100%" />
          </linearGradient>
        </defs>
        <path
          fill={`url(#${gradientId})`}
          d="M43,100 L17,76 L3.90205529,90.9690797 C1.92172697,93.232312 2.15106602,96.6723977 4.41429838,98.652726 C5.40691544,99.5212659 6.68104199,100 8,100 C20.4691114,100 32.1357781,100 43,100 Z"
        />
        <path
          fill="#7800FF"
          d="M60,35 L24,0 L1.95028875,22.9684492 C0.698836027,24.2720458 0,26.0091031 0,27.816172 L0,92 C0,96.418278 3.581722,100 8,100 C5.22328115,100 2.97230578,97.7490246 2.97230578,94.9723058 C2.97230578,93.652957 3.49091151,92.3864768 4.41625972,91.446045 Z"
        />
      </svg>
      {withWordmark && <span className="text-lg font-bold tracking-tight text-fg">Ростелеком</span>}
    </span>
  );
}
